
import { Button } from '@/components/ui/button';
import { Loader2, ArrowRight } from 'lucide-react';
import { usePayment } from '@/context/PaymentContext';
import { useState, useEffect } from 'react';
import { toast } from 'sonner';

const PaymentButton = () => {
  const { packageType, isProcessing, handleProceedToPayment, razorpayReady, finalAmount } = usePayment();
  const isFree = finalAmount <= 0;
  const [localReady, setLocalReady] = useState(false);
  
  useEffect(() => {
    // Check if Razorpay is already loaded
    if (window.Razorpay) {
      setLocalReady(true);
      return;
    }
    
    // Listen for Razorpay load event
    const handleRazorpayLoaded = () => {
      console.log('PaymentButton: Razorpay loaded event received');
      setLocalReady(true);
    };
    
    window.addEventListener('razorpay_loaded', handleRazorpayLoaded);
    
    // Also check every second in case the event was missed
    const checkInterval = setInterval(() => {
      if (window.Razorpay) {
        console.log('PaymentButton: Razorpay detected through interval check');
        setLocalReady(true);
        clearInterval(checkInterval);
      }
    }, 1000);
    
    return () => {
      window.removeEventListener('razorpay_loaded', handleRazorpayLoaded);
      clearInterval(checkInterval);
    };
  }, []);

  // Handle payment initialization with Razorpay check
  const handlePayment = () => {
    // Free orders bypass Razorpay entirely
    if (isFree) {
      handleProceedToPayment();
      return;
    }

    const isRazorpayReady = localReady || razorpayReady || window.Razorpay;
    if (!isRazorpayReady) {
      console.error("Razorpay SDK not loaded yet in PaymentButton");
      toast.error('Payment system is still loading. Please try again in a moment.');
      return;
    }
    
    handleProceedToPayment();
  };

  // Determine button state
  const isRazorpayAvailable = isFree || localReady || razorpayReady || window.Razorpay;

  return (
    <Button 
      onClick={handlePayment}
      disabled={isProcessing || !isRazorpayAvailable}
      className={`w-full ${packageType === 'silver' 
        ? 'bg-brand-blue text-white hover:bg-brand-blue/90' 
        : 'bg-brand-yellow text-brand-blue hover:bg-amber-400'}`}
      size="lg"
    >
      {isProcessing ? (
        <>
          <Loader2 className="mr-2 h-5 w-5 animate-spin" />
          Processing...
        </>
      ) : !isRazorpayAvailable ? (
        <>
          <Loader2 className="mr-2 h-5 w-5 animate-spin" />
          Loading payment system...
        </>
      ) : isFree ? (
        <>
          Redeem Coupon — Get Free Access <ArrowRight className="ml-2 h-5 w-5" />
        </>
      ) : (
        <>
          Proceed to Payment <ArrowRight className="ml-2 h-5 w-5" />
        </>
      )}
    </Button>
  );
};

export default PaymentButton;
